<template>
  <v-card flat>
    <v-card-text>
      <v-data-table
        :items="items"
        :headers="headers"
        :hide-default-footer="isMobile()"
        :hide-default-header="isMobile()"
        no-data-text="Nenhum documento Anexado"
      >
        <template v-slot:[`item.obrigatorio`]="{ item }">
          <v-chip v-if="item.obrigatorio" color="success" x-small
            >Obrigatório</v-chip
          >
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <remover-anexo :anexo="item" v-if="temAnexo(item)" />
          <upload-arquivo :anexo="item" v-else />
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import RemoverAnexo from "./RemoverAnexo.vue";
import UploadArquivo from "./UploadArquivo.vue";
export default {
  components: { UploadArquivo, RemoverAnexo },
  props: {
    items: Array,
  },
  computed: mapState("anexos", ["docs"]),
  data: () => ({
    headers: [
      { text: "Documento", value: "descricao" },
      { text: "", value: "obrigatorio" },
      { text: "", value: "actions" },
    ],
  }),
  methods: {    
    isMobile() {
      return this.$mq == "sm";
    },
    temAnexo(item) {            
      return this.docs.filter((doc) => doc.codanexo == item.codigo).length > 0;
    },
  }
};
</script>

<style>
</style>